import { useState } from 'react'
import { signInWithEmailAndPassword, auth } from 'config/Firebase'
import Alert from 'utils/Alert'
import Loader from 'utils/Loader'

const LoginModal = () => {
  // ===========
  let initial = {
    email: '',
    password: '',
  }
  // =============
  const [formData, setFormData] = useState(initial)
  const [alert, setAlert] = useState({ open: false, msg: '', type: 'success' })
  // submitting
  const [submitting, setSubmitting] = useState(false)

  // ===== Login user =============
  const login = (e) => {
    console.log(formData)
    setSubmitting(true)
    e.preventDefault()
    signInWithEmailAndPassword(auth, formData?.email, formData?.password)
      .then((userCredential) => {
        console.log(userCredential)
        setSubmitting(false)
        const user = userCredential.user
        setAlert({
          msg: `${user?.email} Login successfully!`,
          open: false,
          type: 'success',
        })
      })
      .catch((error) => {
        setSubmitting(false)
        const errorCode = error.code
        const errorMessage = error.message
        setAlert({
          msg: `${errorMessage}, Error Code: ${errorCode} `,
          open: true,
          type: 'error',
        })
      })
  }

  return (
    <div className="page_wrapper">
      <div className="cs_container text_center">
        <form className="cs_form" onSubmit={login}>
          <div className="cs_row align-items-center  py-2">
            <div className="cs_row align-items-center">
              <span className="cs_icons">&#9993;</span>
              <label htmlFor="email">Email :</label>
            </div>
            <input
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              type="email"
              placeholder="Enter email"
              name="email"
              id="email"
              value={formData.email}
            />
          </div>
          <div className="cs_row py-2">
            <div className="cs_row align-items-center">
              <span className="cs_icons">&#8792;</span>
              <label htmlFor="password">password :</label>
            </div>
            <input
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              type="password"
              placeholder="Enter password"
              name="password"
              id="password"
              value={formData.password}
            />
          </div>
          <div className="cs_row py-2 justify-content-center align-items-center">
            <button type="submit" className="cs_btn">
              Login
            </button>
          </div>
        </form>
      </div>
      {/* ========== Alert ==================== */}
      <Alert data={alert} setAlert={setAlert} />
      {submitting && <Loader type="imgloader_fixed" />}
    </div>
  )
}

export default LoginModal
